
export default {

};



// WEBPACK FOOTER //
// ./src/store/modules/file/getters.js